import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material'
import type { CustomPersona } from '../../types/config'

interface PersonaInfoModalProps {
  open: boolean
  onClose: () => void
  personaName: string
  customPersonas: CustomPersona[]
}

const PersonaInfoModal: React.FC<PersonaInfoModalProps> = ({
  open,
  onClose,
  personaName,
  customPersonas,
}) => {
  const customMatch = customPersonas.find(p => p.name === personaName)

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Persona Details</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
          <Typography sx={{ fontWeight: 600 }}>{personaName}</Typography>

          <Box>
            <Typography sx={{ fontSize: 12, fontWeight: 500, color: '#374151', mb: 0.5 }}>
              {customMatch ? 'Persona Prompt' : 'Injected Text'}
            </Typography>
            <Box
              component="pre"
              sx={{
                // White, deliberately, and not the theme's paper token: this box
                // sits on the start screen's Sky cover where a tinted surface
                // reads as dirty. Because it is a fixed light background, the
                // text colour has to be fixed too — inheriting it would put the
                // dark theme's near-white type on white.
                backgroundColor: '#ffffff',
                color: '#111827',
                border: '1px solid #e5e7eb',
                borderRadius: 1,
                p: 1.5,
                fontSize: 12,
                fontFamily: 'monospace',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                m: 0,
              }}
            >
              {customMatch ? customMatch.prompt : personaName}
            </Box>
            {!customMatch && (
              <Typography sx={{ fontSize: 12, color: '#9ca3af', mt: 1 }}>
                Default persona — the name above replaces{' '}
                <code style={{ backgroundColor: '#f3f4f6', padding: '1px 4px', borderRadius: 3, fontSize: 11 }}>
                  {'{{persona}}'}
                </code>{' '}
                in the workflow&apos;s system prompt.
              </Typography>
            )}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="info">Close</Button>
      </DialogActions>
    </Dialog>
  )
}

export default PersonaInfoModal
